<template>
    <div id="ModalClaimNotes">
         <b-modal size="xl" :id="ModalId" :visible="true" scrollable centered no-close-on-backdrop no-close-on-esc :title="TitleWindow" ref="modalcategory" @close="this.emitEventCancel" @ok="this.emitEventOK" ok-only :ok-title="$t('Close')"> 
            <MdTabList v-bind:TabList="tabList" v-bind:ShowTabList="false">
                <div class="tab-content tab-content-no-padding tab-content-custom-pill" id="pills-tabContent-custom">
                    <div class="tab-pane fade show active" id="claimNotes" role="tabpanel">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-row>
                                                <b-col lg="12" md="12" sm="12"> 
                                                        <MdTablePaginationClient 
                                                            v-bind:fields="Fields"
                                                            v-bind:items="this.noteItems"
                                                            v-bind:totalRows="totalRows"                         
                                                            v-bind:isReadOnly="false"          
                                                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                                                            v-bind:currentPage="currentPage"
                                                            v-bind:perPage="perPage"
                                                            v-bind:pageOptions="pageOptions"
                                                            :viewIconEvent="ViewIconEvent"
                                                            :onFiltered="onFiltered"
                                                            :pageChanged="pageChanged"            
                                                            :RowClick="RowClick"                          
                                                            :onRowSelected="onRowSelected"
                                                            :perPageFunction="PerPageFunction">
                                                        </MdTablePaginationClient>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                    </div>
                    <div class="tab-pane fade" id="claimHistory" role="tabpanel">
                                    <div class="row">
                                        <div class="col-12">
                                            <b-row>
                                                <b-col lg="12" md="12" sm="12"> 
                                                        <MdTablePaginationClient 
                                                            v-bind:fields="ARStatusFields"
                                                            v-bind:items="this.statusItems"
                                                            v-bind:totalRows="totalStatusRows"                         
                                                            v-bind:isReadOnly="false"          
                                                            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                                                            v-bind:currentPage="currentPageStatus"
                                                            v-bind:perPage="perPageStatus"
                                                            v-bind:pageOptions="pageOptions"
                                                            :viewIconEvent="ViewIconEvent"
                                                            :onFiltered="onFiltered"
                                                            :pageChanged="pageStatusChanged"            
                                                            :RowClick="RowClick"                          
                                                            :onRowSelected="onRowSelected"
                                                            :perPageFunction="PerStatusPageFunction">
                                                        </MdTablePaginationClient>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                    </div>
                </div>
            </MdTabList>

            
        </b-modal>

        <ClaimNoteModalEdit v-if="showClaimNoteModalEdit"
            v-bind:ModalId="'modalClaimNoteEdit'"
            v-bind:TitleWindow="ModalTitle"
            v-bind:ModelNote="ModelNote"
            v-bind:IsReadOnly="IsReadOnly"
            v-bind:SeqNo="SeqNo"
            v-bind:EmployeeCode="EmployeeCode"
            @getViewOk="closeClaimNoteModalEdit"/>
    </div>
</template>

<script>
import LocalStorage from '@/services/storage.service'
import ClaimHistory from '@/services/claimhistory.service';
import Utils from "@/common/utils";
export default {
    name: "ClaimNotesModal",
    props: {
        ModalId: String,
        TitleWindow: String,  
        items:Array,
        SeqNo:Number,
        arStatusItems: Array,
    },
    data() {
        return {
            ShowMessageIsEmpty:true,
            pageOptions: [5, 10, 15 ],
            currentPage: 1,
            perPage: 10,
            currentPageStatus: 1,
            perPageStatus: 10,
            Fields: [         
              { key: 'name', sortable: true, label: this.$t('Employee Name'), class: 'text-rigth' },
              { key: 'sysDate', sortable: true, label: this.$t('Created Date'), class: 'text-rigth' },
              { key: 'note', sortable: true, label: this.$t('Note'), class: 'text-rigth note-truncate' },
            ],
            ARStatusFields: [         
              { key: 'name', sortable: true, label: this.$t('Employee Name'), class: 'text-rigth' },
              { key: 'sysDate', sortable: true, label: this.$t('Changed Date'), class: 'text-rigth' },
              { key: 'status', sortable: true, label: this.$t('Claim AR Status'), class: 'text-rigth' },
              { key: 'note', sortable: true, label: this.$t('Note'), class: 'text-rigth note-truncate' },
            ],
            showClaimNoteModalEdit: false,
            ModelNote: '',
            IsReadOnly: true,
            ModalTitle: this.$t('View Claim Note'),
            EmployeeCode: LocalStorage.getUserId(),
            tabList: [
                { title: this.$t('Claim Notes'), link: '#claimNotes', active: true },
                { title: this.$t('Claim AR Status History'), link: '#claimHistory' }
            ],
            NotesParameter: {
                SeqNo: this.SeqNo,
                PageNumer: 0,
                PageSize: 0,
            },
            StatusParameter: {
                SeqNo: this.SeqNo,
                PageNumer: 0,
                PageSize: 0,
            },
        }
    },
    computed: {
        noteItems() {
            return this.items;
        },
        statusItems() {
            return this.arStatusItems;
        },
        totalRows() {
            return this.items.length;
        },
        totalStatusRows() {
            return this.arStatusItems.length;
        }
    },
    methods:{
        RowClick(){

        },
        onRowSelected(){

        },
        onFiltered(){

        },
        pageChanged (page) {
            this.currentPage = page;
            //this.getClaimNotesHistory();
          },

        PerPageFunction(perpage){
            this.perPage = perpage;  
            this.currentPage = 1;
            //this.getClaimNotesHistory();   
        },
        
        pageStatusChanged (page) {
            this.currentPageStatus = page;
        },

        PerStatusPageFunction(perpage){
            this.perPageStatus = perpage;  
            this.currentPageStatus = 1;
        },

        emitEventCancel(){
            this.$emit('getCodeConditionOK',true);
        },

        emitEventOK(){
            this.$emit('getCodeConditionOK',true);
        },
        ViewIconEvent(row){
            this.ModelNote = row.note;
            this.IsReadOnly = true;
            this.showClaimNoteModalEdit = true;
        },
        closeClaimNoteModalEdit(){
            this.showClaimNoteModalEdit = false;
            this.IsReadOnly = true;
            this.$emit('refreshNotes')
        },
        async getClaimNotesHistory() {
            this.$emit("load", true)
            this.NotesParameter.SeqNo = this.SeqNo;
            this.NotesParameter.PageSize = this.perPage;
            this.NotesParameter.PageNumber = this.currentPage; 
            await ClaimHistory.getAllNotesDetails(this.NotesParameter).then((response) => {
              this.noteItems = response.data;
              this.noteItems.forEach(element => {
                element.name = element.firstName + " " + element.lastName;
                element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null; 
              })
              this.$emit("load", false)
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
        },
        async getClaimARStatusHistory() {
            this.$emit("load", true)
            this.NotesParameter.SeqNo = this.SeqNo;
            this.NotesParameter.PageSize = this.perPage;
            this.NotesParameter.PageNumber = this.currentPage; 
            await ClaimHistory.getAllARStatusHistory(this.NotesParameter).then((response) => {
              this.statusItems = response.data;
              this.statusItems.forEach(element => {
                element.sysDate = element.sysDate ? Utils.formatterDateToString(element.sysDate) : null; 
              })
              this.$emit("load", false)
            }).catch(error => {
              this.$emit('load', false);
              if (!error.response) {
                  // network error
                  console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),this.$t('Msg.retrieveInfo'),"error");
              } else {
                console.log(error);
                  this.showMessage(this.$tc('Msg.Error'),error,"error");
              }
                })
        },
    }
}
</script>
<style>
.note-truncate {
  max-width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>